/**
 * T2-6086: Lets legacy F7 `payment-info.js` show the React BrandedAlertModal success
 * dialog when the micro-frontend bundle is loaded (same session as react.html).
 */
import React from 'react';
import ReactDOM from 'react-dom';
import PaymentMethodSuccessModal, {
  PaymentMethodSuccessVariant,
} from '../components/Modal/PaymentMethodSuccessModal/PaymentMethodSuccessModal';

const PORTAL_ID = 'tempstars-payment-success-portal';

type ShowPaymentMethodSuccessOptions = {
  variant?: PaymentMethodSuccessVariant;
  cardStatusLabel?: string;
  onConfirm: () => void;
};

function ensurePortal(): HTMLElement {
  let el = document.getElementById(PORTAL_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = PORTAL_ID;
    document.body.appendChild(el);
  }
  return el;
}

function showPaymentMethodSuccessModal(options: ShowPaymentMethodSuccessOptions): void {
  const portal = ensurePortal();

  const unmount = () => {
    ReactDOM.unmountComponentAtNode(portal);
  };

  const handleConfirm = () => {
    unmount();
    options.onConfirm();
  };

  ReactDOM.render(
    <PaymentMethodSuccessModal
      isOpen
      variant={options.variant}
      cardStatusLabel={options.cardStatusLabel}
      onConfirm={handleConfirm}
      onClose={handleConfirm}
    />,
    portal,
  );
}

export function registerPaymentMethodSuccessBridge(): void {
  const ts: any = (window as any).TempStars || {};
  ts.showPaymentMethodSuccessModal = showPaymentMethodSuccessModal;
  (window as any).TempStars = ts;
}
